import qs from 'qs';
import wretch from 'wretch';

import { ConfigManager } from '../../../application/config/ConfigManager';
import { IConfig } from '../../../application/config/IConfig';
import { getCurrentCsrfCookie } from '../../../application/csrfProtection/getCurrentCsrfCookie';
import { IRestService } from './IRestService';
import { RestErrorHandler } from './RestErrorHandler';

export class RestService implements IRestService {
  constructor(protected config: IConfig = ConfigManager.getConfig(), protected errorHandler = new RestErrorHandler()) {}

  getConfig() {
    return this.config;
  }

  async postForLogin<Request = any, Response = boolean>(url: string, data: Request): Promise<Response> {
    return await this.request().url(url).post(data).json<Response>().catch(this.handleError);
  }

  async post<Request = any, Response = boolean>(url: string, data: Request): Promise<Response> {
    return await this.request().url(url).post(data).json<Response>().catch(this.handleError);
  }

  async postForRefreshToken<Request = any, Response = boolean>(url: string, data: Request): Promise<Response> {
    return await this.request().url(url).post(data).json<Response>().catch(this.handleError);
  }

  async put<Request = any, Response = boolean>(url: string, data: Request): Promise<Response> {
    return await this.request().url(url).put(data).json<Response>().catch(this.handleError);
  }

  async delete<Response = boolean>(url: string): Promise<Response> {
    return await this.request().url(url).delete().fetchError(this.handleError).json<Response>().catch(this.handleError);
  }

  async get<QueryData = any, QueryResult = any>(url: string, queryData?: QueryData): Promise<QueryResult> {
    const paramsString = qs.stringify(queryData || {});
    const result = await this.request()
      .url(`${url}?${paramsString}`)
      .get()
      .fetchError(this.handleError)
      .json<QueryResult>()
      .catch(this.handleError);

    return result;
  }

  handleError = (errorResponse: any) => {
    return this.errorHandler.handle(errorResponse);
  };

  protected request() {
    const request = wretch()
      .options({
        headers: {
          ...({ 'x-csrf-token': `${getCurrentCsrfCookie()}` }),
        },
        credentials: 'include',
      })
      .errorType('json');
    const oldJson = request.json;
    request.json = (...props) => {
      const result = oldJson(...props);
      return result;
    };
    return request;
  }
}
